import { notify } from './toastify';
import { setCommonDataLoader, setPresignedUrl } from '../redux/commonSlice';
import store from '../redux/store';
import endPoints from '../api/endpoint';
import { getApiCall } from '../api/methods';

interface UploadedFile {
  url: string;
  name: string;
}
export const getPresignedUrl = async (
  fileName: string,
): Promise<{ preSignedUrl: string; baseUrl: string }> => {
  const apiEndpoint = endPoints.getPresignedUrl;

  return new Promise((resolve, reject) => {
    store.dispatch(setCommonDataLoader(true));

    getApiCall(
      `${apiEndpoint}?filename=${fileName}`,
      (response: any) => {
        const { data } = response;
        if (data && data.data && data.data.preSignedUrl && data.data.baseUrl) {
          store.dispatch(setPresignedUrl(data.data.preSignedUrl));
          resolve({
            preSignedUrl: data.data.preSignedUrl,
            baseUrl: data.data.baseUrl,
          });
        } else {
          reject('No presigned URL or base URL found in the response');
        }
        store.dispatch(setCommonDataLoader(false));
      },
      (error: any) => {
        console.error('Error while fetching presigned URL:', error);
        store.dispatch(setCommonDataLoader(false));
        reject('Error while fetching presigned URL');
        notify('error', 'Error while fetching presigned URL');
      },
    );
  });
};

// export const uploadToS3 = async (file: File): Promise<UploadedFile> => {
//   try {
//     // Step 1: Get the presigned URL and baseUrl
//     const { preSignedUrl, baseUrl } = await getPresignedUrl(file.name);
//     console.log('Presigned URL:', preSignedUrl);
//     console.log('Base URL:', baseUrl);

//     // Step 2: Define headers for the PUT request
//     const headers = {
//       'Content-Type': file.type,
//     };

//     // Step 3: Convert the file to a Blob (optional as `File` extends `Blob`)
//     const fileBlob = new Blob([file], { type: file.type });

//     // Step 4: Upload the file to S3 using the presigned URL
//     const response = await fetch(preSignedUrl, {
//       method: 'PUT',
//       headers,
//       body: fileBlob,
//     });

//     // Check if the upload was successful
//     if (response.ok) {
//       const uploadedFileUrl = `${baseUrl}${file.name}`;
//       return { url: uploadedFileUrl, name: file.name };
//     } else {
//       throw new Error(`File upload failed with status: ${response.status}`);
//     }
//   } catch (error) {
//     console.error('Upload failed:', error);
//     throw new Error('Upload failed');
//   }
// };
// export const uploadToS3 = async (
//   file: File,
//   setUploadProgress?: any
// ): Promise<UploadedFile> => {
//   return new Promise((resolve, reject) => {
//     const s3 = reelBucket
//     const key = AWS_FOLDER_PATH + `${Date.now()}_${file.name}`
//     const params = {
//       Bucket: S3_BUCKET || '',
//       Key: key,
//       Body: file,
//       ACL: 'private', // Set the ACL as needed
//     }
//     const name = generateRandomString(5) + file.name.replaceAll(' ', '-')
//     const fileURl = AWS_FOLDER_PATH + name

//     const options = {
//       partSize: 5 * 1024 * 1024, // 5MB parts
//       queueSize: 4, // 4 concurrent uploads
//     }

//     const upload = s3.upload(params, options)

//     upload.on('httpUploadProgress', (progress) => {
//       const percentage = Math.round((progress.loaded / progress.total) * 100)

//       console.log('=>>>>progressINMax', percentage)
//       setUploadProgress && setUploadProgress(percentage)
//     })

//     upload
//       .promise()
//       .then((data) => {
//         // console.log('data url s3', data)
//         // console.log('=>>>>>>>>>>>>', s3Url + key)
//         resolve({ url: s3Url + key, name: file.name })

//         setUploadProgress && setUploadProgress(null) // Reset progress after successful upload
//       })
//       .catch((error) => {
//         console.log('error', error)
//         reject(error)
//         setUploadProgress && setUploadProgress(null) // Reset progress after failed upload
//       })
//   })
// }

// upload func as Vendor pannel

// function sanitizeFileName(name: string) {
//   return name.replace(/[^a-z0-9.\-_]/gi, '_'); // replace special characters with _
// }

function sanitizeFileName(name: string) {
  return name.replace(/[^a-zA-Z0-9.\-_\s]/g, '_');
}

export const uploadToS3 = async (
  file: File,
  setUploadProgress?: (progress: number) => void,
): Promise<UploadedFile> => {
  try {
    // Step 1: Get the presigned URL and baseUrl

    const safeName = sanitizeFileName(file.name);
    // const safeName = file.name;
    const { preSignedUrl, baseUrl } = await getPresignedUrl(safeName);
    // console.log('Presigned URL:', preSignedUrl);
    // console.log('Base URL:', baseUrl);

    // Step 2: Convert the file to a Blob
    const fileBlob = new Blob([file], { type: file.type });

    // Step 3: Create XMLHttpRequest to track upload progress
    return new Promise<UploadedFile>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', preSignedUrl, true);
      xhr.setRequestHeader('Content-Type', file.type);

      // Track upload progress
      xhr.upload.onprogress = event => {
        if (event.lengthComputable && setUploadProgress) {
          const progress = Math.round((event.loaded / event.total) * 100);
          setUploadProgress(progress);
        }
      };

      // Handle upload success
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          const uploadedFileUrl = `${baseUrl}${safeName}`;
          resolve({ url: uploadedFileUrl, name: safeName });
        } else {
          reject(new Error(`File upload failed with status: ${xhr.status}`));
        }
      };

      // Handle errors
      xhr.onerror = (e: any) => {
        console.log('Error =>', e);
        reject(new Error('Upload failed due to network error.'));
      };

      // Send the file
      xhr.send(fileBlob);
    });
  } catch (error) {
    store.dispatch(setCommonDataLoader(false));
    console.error('Upload failed:', error);
    notify('Upload failed', 'error');
    // throw new Error('Upload failed');
  }
};
